





























































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import OpportunityLocationGeneralDetailsEdit from '@/components/Opportunities/OpportunityLocationGeneralDetailsEdit.vue';
import OpportunityLocationAddressEdit from '@/components/Opportunities/OpportunityLocationAddressEdit.vue';

@Component({
  name: 'OpportunityVenueTab',
  components: { OpportunityLocationGeneralDetailsEdit, OpportunityLocationAddressEdit },
})
export default class extends GiganautVue {
  get opportunity() { return OpportunityDetailsModule.opportunity; }

  get statusLabel(): string {
    if (!this.opportunity) return '';
    if (this.opportunity.locationId) return 'Existing';
    if (this.opportunity.prospectLocationName || this.opportunity.prospectLocationAddress1) return 'New';
    return '';
  }

  get hasAnyDetails(): boolean {
    if (!this.opportunity) return false;
    return !!this.opportunity.location
      || !!this.opportunity.prospectLocationName
      || !!this.opportunity.prospectLocationAddress1;
  }

  locationField(linkedKey: string, prospectKey: string): string {
    if (!this.opportunity) return '';
    if (this.opportunity.location) return (this.opportunity.location as any)[linkedKey] || '';
    return (this.opportunity as any)[prospectKey] || '';
  }

  get locationTypeDisplay(): string {
    if (!this.opportunity) return '';
    const linked = this.opportunity.location as any;
    if (linked && linked.locationType && linked.locationType.name) return linked.locationType.name;
    const proLT = (this.opportunity as any).prospectLocationType;
    if (proLT && proLT.name) return proLT.name;
    return '';
  }

  get locationAddressDisplay(): string {
    if (!this.opportunity) return '';
    if (this.opportunity.location) {
      const loc = this.opportunity.location as any;
      return [
        loc.buildingNameNumber, loc.streetRoadBlock, loc.locality,
        loc.cityTown, loc.stateProvinceRegion, loc.postZipCode, loc.countryCode,
      ].filter((p: string) => !!p).join(', ');
    }
    return [
      this.opportunity.prospectLocationAddress1,
      this.opportunity.prospectLocationAddress2,
      this.opportunity.prospectLocationLocality,
      this.opportunity.prospectLocationCity,
      this.opportunity.prospectLocationRegion,
      this.opportunity.prospectLocationPostcode,
      this.opportunity.prospectLocationCountry,
    ].filter(p => !!p).join(', ');
  }

  get locationGeometry(): { lat: number; lng: number } | null {
    if (!this.opportunity) return null;
    const linked = this.opportunity.location as any;
    if (linked && linked.geometry && (linked.geometry.lat || linked.geometry.lng)) {
      return { lat: linked.geometry.lat, lng: linked.geometry.lng };
    }
    if (this.opportunity.prospectLocationLatitude != null && this.opportunity.prospectLocationLongitude != null) {
      return { lat: this.opportunity.prospectLocationLatitude, lng: this.opportunity.prospectLocationLongitude };
    }
    return null;
  }
}
